import { useState } from 'react';
import { Button } from '@/components/Button/Button';
import { t } from '@/lib/i18n';
import styles from './HumanComingSoon.module.css';

export interface HumanComingSoonProps {
  onBack: () => void;
  onBackToTeam: () => void;
  canAddHumans?: boolean;
  onDirectHire?: () => void;
}

export function HumanComingSoon({
  onBack,
  onBackToTeam,
  canAddHumans,
  onDirectHire,
}: HumanComingSoonProps) {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  function notify() {
    if (!email.trim()) return;
    // Stub: no backend wiring. Confirmation shown locally.
    setSubmitted(true);
    setEmail('');
    setTimeout(() => setSubmitted(false), 3000);
  }

  return (
    <div className={styles.page} data-testid="human-coming-soon">
      <div className={styles.iconBox} aria-hidden="true">
        👥
      </div>
      <div className={styles.label}>{t('COMING SOON')}</div>
      <h1 className={styles.title}>{t('Adding humans through Linqage is on the way.')}</h1>
      <p className={styles.subtitle}>
        {t(
          "We're building a way to source vetted contractors and full-time hires using the same brief-driven workflow you use for AI Members. Want early access?",
        )}
      </p>
      <div className={styles.formCard}>
        <input
          type="email"
          className={styles.emailInput}
          placeholder={t('you@company.com')}
          aria-label={t('Email address for early-access notification')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') notify();
          }}
        />
        <Button type="button" variant="primary" size="md" onClick={notify} disabled={!email.trim()}>
          {t('Notify me')} →
        </Button>
      </div>
      {submitted ? (
        <div className={styles.confirmation}>{t("Thanks — we'll be in touch.")}</div>
      ) : null}
      <div className={styles.links}>
        <button type="button" className={styles.link} onClick={onBack}>
          ← {t('Add an AI Member instead')}
        </button>
        <button type="button" className={styles.link} onClick={onBackToTeam}>
          {t('Back to team')}
        </button>
      </div>
      {canAddHumans && onDirectHire ? (
        <div className={styles.devNote}>
          <span className={styles.devBadge}>DEV</span>
          {t('Email verification is off — you can add a human user directly.')}
          <button type="button" className={styles.devButton} onClick={onDirectHire}>
            {t('Add human user')} →
          </button>
        </div>
      ) : null}
    </div>
  );
}
